import { render, staticRenderFns } from "./BulletinDetails.vue?vue&type=template&id=cea8c906"
import script from "./BulletinDetails.vue?vue&type=script&lang=js"
export * from "./BulletinDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports